<template>
  <v-form ref="listWelderForm">
    <v-container>
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="pb-0">
          <div class="d-flex" v-if="filterBadge.length > 0">
            <v-chip small class="mr-2" v-for="(text, index) in filterBadge" :key="index">{{text}}</v-chip>
          </div>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" :class="[$vuetify.breakpoint.mdAndDown ? 'text-left' : 'text-right']">
          <v-btn v-if="$checkRight(['edit_welder'])" :to="'welder/create'" class="primary" small>Add</v-btn>
          <v-btn @click="openDrawer = !openDrawer" class="ml-2" small color="#eee">
            <v-icon small>mdi-filter</v-icon>
          </v-btn>
          <v-btn @click="deactiveWelder" class="ml-2" small color="#eee" v-if="$checkRight(['edit_welder'])">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn @click="clearFilter(false);$refreshDataTable()" class="ml-2" small color="#eee">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Datatable -->
      <datatable
        ref="welder_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
      />
      <!-- Filter -->
      <popup-drawer :value.sync="openDrawer" :openDrawer="openDrawer">
        <v-col cols="12">
          <v-text-field
            placeholder="Name"
            label="Name"
            v-model="filter.name"
            autofocus
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            placeholder="Qualification"
            label="Qualification"
            v-model="filter.qualification"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            clearable
            return-object
            item-value="id"
            label="Rating"
            placeholder="Rating"
            v-model="filter.rating"
            :items="[{id: 1, text: '1'}, {id: 2, text: '2'}, {id: 3, text: '3'}, {id: 4, text: '4'}, {id: 5, text: '5'}]"
            :small-chips="true">
          </v-select>
        </v-col>
        <v-col cols="12">
          <v-text-field
            placeholder="Experience"
            label="Experience"
            v-model="filter.experience"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            placeholder="From Salary"
            label="From Salary"
            v-model="filter.from_salary"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            placeholder="To Salary"
            label="To Salary"
            v-model="filter.to_salary"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            clearable
            return-object
            item-value="id"
            label="Status"
            placeholder="Status"
            v-model="filter.status"
            :items="[{id: 0, text: 'Active', color: 'success'}, {id: 1, text: 'Inactive', color: 'warning'}]"
            :small-chips="true">
            <template #selection="{ item }">
              <v-chip :color="item.color" small>{{item.text}}</v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn @click="filterData" class="mt-4" color="primary" small>Filter</v-btn>
          <v-btn @click="clearFilter" class="mt-4 ml-2" small>Clear</v-btn>
        </v-col>
      </popup-drawer>
    </v-container>
    <!-- Logout welder confirmation-->
    <v-dialog v-model="openLogoutConfirmationModel" width="600">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-text>Are you sure you want logout this welder ?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="logOutWelder()">Yes</v-btn>
          <v-btn color="primary" text @click="openLogoutConfirmationModel = false; logOutWelderData = {}">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  computed: {
    filterBadge () {
      const fList = []
      Object.keys(this.filterDisplay).map((x, i) => {
        if (typeof this.filterDisplay[x] === 'object') {
          fList.push(this.filterDisplay[x].text)
        } else if (this.filterDisplay[x]) {
          fList.push(this.filterDisplay[x])
        }
      })
      return fList
    }
  },
  created () {
    if (!this.$checkRight(['edit_welder'])) {
      this.tableOption.headers.shift()
    }
    this.$eventBus.$on('$logOutWelderEvent', (data) => {
      if (data) {
        this.logOutWelderData = data
        this.openLogoutConfirmationModel = true
      }
    })
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      tableOption: {
        url: 'getWelderAll',
        editUrl: 'welder/edit',
        deleteRoute: 'deactiveWelder',
        moduleName: 'welder',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80 },
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Qualification', value: 'qualification' },
          { text: 'Rating', value: 'rating' },
          { text: 'Experience', value: 'experience' },
          { text: 'Salary', value: 'salary' },
          { text: 'Login Status', value: 'logoutAction', align: 'center', sortable: false },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          0: { color: 'green', text: 'Active' },
          1: { color: 'orange', text: 'Inactive' }
        }
      },
      openDrawer: false,
      filter: {},
      filterDisplay: {},
      logOutWelderData: {},
      openLogoutConfirmationModel: false
    }
  },
  watch: {
    options: {
      handler () {
      },
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactiveWelder () {
      this.$refs.welder_datatable.massDeleteTableData()
    },
    filterData () {
      this.$eventBus.$emit('$filterDataTable', this.filter)
      this.openDrawer = false
      this.filterDisplay = this.filter ? JSON.parse(JSON.stringify(this.filter)) : {}
    },
    clearFilter (callEmit = true) {
      if (callEmit) {
        this.$eventBus.$emit('$filterDataTable', {})
      }
      this.openDrawer = false
      this.filter = {}
      this.filterDisplay = {}
    },
    logOutWelder () {
      this.openLogoutConfirmationModel = false
      if (this.logOutWelderData.CompanyID !== undefined && this.logOutWelderData.WelderPasscode !== undefined) {
        const route = 'api/ws/master/WelderLogout?CompanyID=' + this.logOutWelderData.CompanyID + '&WelderPasscode=' + this.logOutWelderData.WelderPasscode
        this.$axios.get(route, { requestForSearchable: true }).then((res) => {
          if (Object.prototype.hasOwnProperty.call(res.data, 'Data')) {
            this.$eventBus.$emit('$globalSnackbar', 'success', res.data.Data)
            this.$refreshDataTable()
          } else if (Object.prototype.hasOwnProperty.call(res.data, 'ErrorCode') && res.data.ErrorCode !== 'ERR-422') {
            this.$eventBus.$emit('$globalSnackbar', 'red', res.data.Error)
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', 'Some Error')
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$eventBus.$emit('$globalSnackbar', 'red', 'Some Error')
      }
    }
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
/* .v-data-table-header > tr > th:first-child{
  background: red;
} */
</style>
